import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  createTypeSurgeryAction,
  getSurgeryAction,
} from "../../Actions/SurgeryAction/SurgeryAction";
import { MdOutlineSaveAlt } from "react-icons/md";

const TypeSurgeryModal = ({ closeModal }) => {
  const [inputValue, setInputValue] = useState({
    surgery_id: "",
    en_name: "",
    ku_name: "",
  });

  useEffect(() => {
    dispatch(getSurgeryAction());
  }, []);
  const surgeryList = [];
  const getSurgery = useSelector((state) => state.getSurgery);
  const { surgeries, loading } = getSurgery;
  const createTypeSurgery = useSelector((state) => state.createTypeSurgery);
  const { error } = createTypeSurgery;

  surgeries?.map((surgery) => {
    surgeryList.push({
      label: surgery.name,
      value: surgery.id,
    });
  });

  const dispatch = useDispatch();
  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(
      createTypeSurgeryAction(
        inputValue.surgery_id,
        inputValue.en_name,

      )
    );

  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container">
          <div className="modal-header ">
            <h3 className="cursor-pointer" onClick={closeModal}>
              X
            </h3>
          </div>

          <form action="" onSubmit={handleSubmit}>
            <div className="w-full">
              <Select
                options={surgeryList}
                onChange={(selectOpt) => {
                  setInputValue({
                    ...inputValue,
                    surgery_id: selectOpt.value,
                  });
                }}
              />

              <p className="text-red-500 ">{error && error.surgery_id}</p>
            </div>
            <div className="flex gap-2 w-full">
              <div className="flex flex-col w-full">
                <div>
                  <label htmlFor="en_name">Organ *</label>
                </div>
                <input
                  type="text"
                  name="en_name"
                  className="input w-full p-1"
                  onChange={handleInputChange}
                  value={inputValue.en_name}
                />

                <p className="text-red-500 ">{error && error.en_name}</p>
              </div>

          
            </div>

            <button className="btn-primary mt-2 flex items-center gap-2">
              Save <MdOutlineSaveAlt />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TypeSurgeryModal;
